import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const faqs = [{
  q: 'Does it work for any type of life coach?',
  a: 'Yes. The sessions are organized by theme (mindset, action, emotions, communication, relationships, renewal) and work with any methodology — ICF, NLP, transformational, ontological, or your own training.'
}, {
  q: 'How do I receive the material?',
  a: 'Instant PDF download the moment your purchase is confirmed. Open it on desktop, tablet, or phone, and print anything you need.'
}, {
  q: 'Can I use the material under my own brand?',
  a: 'Yes. The client worksheets and deliverables are built for you to add your logo and use with your clients.'
}, {
  q: 'Is it a course? Do I have to study anything?',
  a: 'No. It’s ready to use. Open the tome, pick the session, run it. Zero filler theory.'
}, {
  q: 'What if I just got certified and don’t have clients yet?',
  a: 'Perfect timing. Tome 1 (onboarding + Session Zero) and the Stuck Client Emergency Playbook are built for exactly that stage.'
}, {
  q: 'What if it’s not for me?',
  a: '7-day guarantee, full refund, no questions asked.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="w-full bg-white" data-id="element-97" data-mp="kha1c8uguanj">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-98" data-mp="6qf09iq7kxui">
        <h2 id="faq-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-99" data-mp="bhwpxams7c06">
          Frequently asked questions
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-100" data-mp="3swtt13fhnl0h">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="rounded-2xl border border-cream-dark bg-cream overflow-hidden" data-id="element-101" data-mp="3jxq6fph44nh8" data-mpi={i}>
                <h3 data-id="element-102" data-mp="3o1eesadkjn3j">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-4 sm:py-5 font-semibold text-ink hover:text-sage transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sage/40" data-id="element-103" data-mp="1ugkwa7nhy2kc">
                    <span className="text-[15px] sm:text-base" data-id="element-104" data-mp="2ddcl0wlt59vs">{faq.q}</span>
                    <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-sage transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-105" data-mp="28hf52regi5jj" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-106" data-mp="s35hhzi1gktr">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-107" data-mp="o0iuqd085q3f">
                      <p className="px-5 sm:px-6 pb-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-108" data-mp="3dfsj0gy7r9gf">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}